import React from 'react';
import {
  AssemblyType,
  AssemblyTypeKey,
  RpCheck2Type,
  TestResult,
} from '@ecosconnect/core/src/types/jobFormData';
import { getTestStatus } from '@ecosconnect/core/src/helpers/backflow/status';
import StatusChip from '../../Status/StatusChip';
import { constantToLabel } from '@ecosconnect/core/src/helpers/string';

type BackflowTestResultStatusProps = {
  test: TestResult;
  assemblyType: AssemblyTypeKey;
  rpCheck2Type: RpCheck2Type;
};

const BackflowTestResultStatus: React.FC<BackflowTestResultStatusProps> = ({
  test,
  assemblyType,
  rpCheck2Type,
}) => {
  const status = getTestStatus(test, AssemblyType[assemblyType], rpCheck2Type);
  return (
    <StatusChip
      status={
        status === 'PASS'
          ? 'success'
          : status === 'FAIL'
            ? 'error'
            : status === 'INCOMPLETE'
              ? 'default'
              : undefined
      }
    >
      {constantToLabel(status)}
    </StatusChip>
  );
};

export default BackflowTestResultStatus;
